export default "__VITE_ASSET__iQoxms3A__"